(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/betslip-selector-goal-count/assets/javascripts/betslips/standard.js') >= 0) return;  svs.modules.push('/components/tipsen/betslip-selector-goal-count/assets/javascripts/betslips/standard.js');
"use strict";

var _svs$core$config$data, _svs$core$config$data2;
const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const format = svs.utils.format;
const clx = svs.components.lbUtils.clx;
const _svs$components$tipse = svs.components.tipsen.betslipComponents,
  Betslip = _svs$components$tipse.Betslip,
  useBetslipContext = _svs$components$tipse.useBetslipContext;
const _svs$components$tipse2 = svs.components.tipsen.engine.selectors.couponSelectors,
  selectSystemSize = _svs$components$tipse2.selectSystemSize,
  selectNumberOfCompletedBoards = _svs$components$tipse2.selectNumberOfCompletedBoards;
const isSelfService = (_svs$core$config$data = (_svs$core$config$data2 = svs.core.config.data.svsconfig) === null || _svs$core$config$data2 === void 0 ? void 0 : _svs$core$config$data2.isSelfService) !== null && _svs$core$config$data !== void 0 ? _svs$core$config$data : false;
const Standard = () => {
  const _useBetslipContext = useBetslipContext(),
    couponId = _useBetslipContext.couponId,
    isCouponValidWithDelay = _useBetslipContext.isCouponValidWithDelay,
    isMedium = _useBetslipContext.isMedium,
    price = _useBetslipContext.price;
  const completedBoards = useSelector(state => selectNumberOfCompletedBoards(state, couponId));
  const selectedSystemSize = useSelector(state => selectSystemSize(state, couponId, 0));
  const numberOfRows = completedBoards > 0 ? selectedSystemSize : 0;
  const isPlayer = svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER);
  const isAnonymous = svs.core.userSession.isAnonymous();
  const shouldDisplayBalance = isCouponValidWithDelay && (isAnonymous || isPlayer) && !isSelfService && isMedium;
  const blockName = 'pg_tipsen_betslip__content';
  const classNames = clx(blockName, {
    ["".concat(blockName, "--valid_coupon")]: isCouponValidWithDelay
  });
  return React.createElement("div", {
    className: classNames
  }, React.createElement("span", {
    className: "pg_tipsen_betslip_system_info"
  }, React.createElement(Betslip.RowsView, {
    numberOfRows: numberOfRows,
    numRows: completedBoards
  }, React.createElement(Betslip.BetslipLabel, null))), shouldDisplayBalance && React.createElement("span", {
    className: "pg_tipsen_betslip_balance"
  }, React.createElement(Betslip.BalanceView, null)), React.createElement("div", {
    className: "pg_tipsen_betslip_price"
  }, format.Currency(price), "\xA0KR"), React.createElement("span", {
    className: "pg_tipsen_betslip_pay_button pg_tipsen_betslip_pay_button--with-progressbar"
  }, React.createElement(Betslip.ProgressBar, null), isCouponValidWithDelay && React.createElement(Betslip.PayButton, null)));
};
setGlobal('svs.components.tipsen.betslipSelectorGoalCount.betslips.Standard', Standard);

 })(window);